import { Autocomplete, Box, Chip, Divider, Grid, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography } from '@mui/material';
import React, { Component } from 'react';
import axios from "axios";
import Api from '../../customlib/Api';
import Global from '../../customlib/Global';
import moment from 'moment';
import DateRangePickerRich from '../../customlib/DateRangePickerRich';
import { Chart as ChartJS, ArcElement, Tooltip, Legend, BarElement, CategoryScale, LinearScale, Title } from 'chart.js';
import { Bar, Pie } from 'react-chartjs-2';
import { Groups, RateReview, HelpOutline, SentimentSatisfiedAlt, ReportProblem } from '@mui/icons-material';

ChartJS.register(ArcElement, Tooltip, Legend, BarElement, 
    CategoryScale,
    LinearScale,
    BarElement,
    Title);

class CsReport extends Component {
    state = { 
        startDate: moment().tz("asia/jakarta"),
        endDate: moment().tz("asia/jakarta"),
        csLeadsReport: [],
        csLeadsReporLoading: false,
        csComplaintCategoriesReport: [],
        csComplaintCategoriesLoading: false,
        csHelpCategoriesReport: [],
        csHelpCategoriesLoading: false,
        csSatisfactionReport: [],
        csSatisfactionLoading: false,
        csRevisionNotes: [],
        csRevisionNotesLoading: false,
        users: [],
        selectedUser: {id: 0, name: "ALL CS"},
        dataCsComplaintCategories: {
            labels: ['Konfirmasi Pesanan', 'Complaint'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)'
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        dataCsResponTime: {
            indexAxis: "y",
            labels: ['Average', 'Fastest', 'Slowest'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    // 'rgba(255, 99,/, 86, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        dataCsCustomerSatisfaction: {
            labels: ['Puas', 'Belum Puas'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        dataCsHelpCategories: {
            labels: [
                'Foto hasil produk belum ada', 
                'Produk tidak sesuai dengan request', 
                'Produk rusak', 
                'Foto lokasi produk belum ada'],
            datasets: [
                {
                label: '',
                data: [],
                backgroundColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderColor: [
                    'rgba(255, 99, 132, 1)',
                    'rgba(54, 162, 235, 1)',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                ],
                borderWidth: 1,
                },
            ],
        },
        test: {
    "labels": [
        "Konfirmasi Pesanan",
        "Complaint"
    ],
    "datasets": [
        {
            "label": "",
            "data": [
                11,
                48,
                1
            ],
            "backgroundColor": [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)"
            ],
            "borderColor": [
                "rgba(255, 99, 132, 1)",
                "rgba(54, 162, 235, 1)"
            ],
            "borderWidth": 1
        }
    ]
}
     } 

    loadCsLeadsReport = () => {
        this.setState({csLeadsReporLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    // appProfileId: Global.getAppProfile()._id,
                    appProfileId: Global.getSwitchAppProfileId(),
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csLeadsReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    if(data.success === true){
                        this.setState({csLeadsReporLoading: false, csLeadsReport: data.data});
                    }else{
                        this.setState({csLeadsReporLoading: false, csLeadsReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csLeadsReporLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsComplainCategoriesReport = () => {
        this.setState({csComplaintCategoriesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    // appProfileId: Global.getAppProfile()._id,
                    appProfileId: Global.getSwitchAppProfileId(),
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csComplaintCategoriesReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsComplaintCategories};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.complaintCategory);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;

                        this.setState({csComplaintCategoriesLoading: false, csComplaintCategoriesReport: data.data, dataCsComplaintCategories: chartData}, () => {
                            console.log("dataCsComplaintCategories", this.state.dataCsComplaintCategories);
                        });
                    }else{
                        this.setState({csComplaintCategoriesLoading: false, csComplaintCategoriesReport: [], dataCsComplaintCategories: chartData});
                    }
                })
                .catch((error) => {
                  this.setState({csComplaintCategoriesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsHelpCategoriesReport = () => {
        this.setState({csHelpCategoriesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    // appProfileId: Global.getAppProfile()._id,
                    appProfileId: Global.getSwitchAppProfileId(),
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csHelpCategoriesReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsHelpCategories};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.helpCategory);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;
                        this.setState({csHelpCategoriesLoading: false, csHelpCategoriesReport: data.data, dataCsHelpCategories: chartData});
                    }else{
                        this.setState({csHelpCategoriesLoading: false, csHelpCategoriesReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csHelpCategoriesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsSatisfactionReport = () => {
        this.setState({csSatisfactionLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    // appProfileId: Global.getAppProfile()._id,
                    appProfileId: Global.getSwitchAppProfileId(),
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csCustomerSatisfactionReport(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    const chartData = {...this.state.dataCsCustomerSatisfaction};
                    let arrLabels = [];
                    let arrData = [];
                    if(data.success === true){
                        data.data.forEach(element => {
                            arrLabels.push(element.review);
                            arrData.push(element.leads.length);
                        });
                        chartData.labels = arrLabels;
                        chartData.datasets[0].data = arrData;
                        this.setState({csSatisfactionLoading: false, csSatisfactionReport: data.data, dataCsCustomerSatisfaction: chartData});
                    }else{
                        this.setState({csSatisfactionLoading: false, csSatisfactionReport: []});
                    }
                })
                .catch((error) => {
                  this.setState({csSatisfactionLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadCsRevisionNotes = () => {
        this.setState({csRevisionNotesLoading: true}, () => {
            var userData = Global.get();
                const params = {
                    startDate: this.state.startDate.format("Y-M-D"),
                    endDate: this.state.endDate.format("Y-M-D"),
                    // appProfileId: Global.getAppProfile()._id,
                    appProfileId: Global.getSwitchAppProfileId(),
                    csUserId: this.state.selectedUser?.id ?? 0
                }
            
                console.log("PARAMS", params);
            
                axios
                .post(Api.csRevisionNotes(), params, Api.getRequestHeader())
                .then((response) => {
                    const data = response.data;
                    if(data.success === true){
                        this.setState({csRevisionNotesLoading: false, csRevisionNotes: data.data});
                    }else{
                        this.setState({csRevisionNotesLoading: false, csRevisionNotes: []});
                    }
                })
                .catch((error) => {
                  this.setState({csRevisionNotesLoading: false});
                  console.error("There was an error!", userData.user.id, error);
                });
        });
    }

    loadUsersBySlugRoles = () => {
    
            const params = {
                slugRoles: ["customer-service", "cs-purchase", "purchasing", "cs-payment", "rangkaian-bunga", "bd-staff-intern"]
                // slugRole: "account-executive"
            };
    
            axios
            // .post(Api.getSalesTeleUserList(), {}, Api.getRequestHeader())
            .post(Api.userBySlugRoles(), params, Api.getRequestHeader())
            .then((response) => {
                console.log("SALESTELEUSER : ", response.data.data);
                let usersData = [{id: 0, name: "All CS"}];

                response.data.data.forEach(item => {
                    usersData.push(item);
                });
                this.setState({users: usersData});
            })
            .catch((error) => {
                console.error("There was an error!", error);
            });
        };

    componentDidMount(){
        this.reloadAll();
    }

    reloadAll = () => {
        this.loadCsLeadsReport();
        this.loadCsComplainCategoriesReport();
        this.loadCsHelpCategoriesReport();
        this.loadCsSatisfactionReport();
        this.loadCsRevisionNotes();
        this.loadUsersBySlugRoles();
    }

    handleDateChanged = (dateRange) => {
        if(dateRange && dateRange[0] && dateRange[1]){
            this.setState({startDate: dateRange[0], endDate: dateRange[1]}, () => {
                this.reloadAll();
            })
        }
    }

    handleSelectionChanged = (selected) => {
        console.log(`SELECTED : ${selected}`);
        let findSelectedUser = this.state.users.find(item => item.name === selected);

        if(findSelectedUser){
            this.setState({selectedUser: findSelectedUser}, this.reloadAll);
        }
    }

    handleCbUserChanged = (event) => {
        console.log(`SELECTED : ${event.target.value}`);
        // let findSelectedUser = this.state.users.find(item => item.name === selected);

        // if(findSelectedUser){
            this.setState({selectedUser: event.target.value}, this.reloadAll);
        // }
    }

    renderCard = ({ icon, title, loading, children }) => (
        <Paper
            variant="outlined"
            sx={{
                borderRadius: "10px",
                p: 1.5,
                height: "100%",
                display: "flex",
                flexDirection: "column",
            }}
        >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                {icon}
                <Typography variant="subtitle2" fontWeight={700}>{title}</Typography>
            </Box>
            {loading ? <LinearProgress sx={{ mt: 1, mb: 1.5, borderRadius: "4px" }} /> : <Divider sx={{ mt: 1, mb: 1.5 }} />}
            {children}
        </Paper>
    )

    renderCountTable = (columns, rows, getLabel, getCount, emptyText) => (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ fontWeight: 700, bgcolor: "#f5f5f5" }}>{columns[0]}</TableCell>
                        <TableCell align="right" sx={{ fontWeight: 700, bgcolor: "#f5f5f5" }}>{columns[1]}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(!rows || rows.length === 0) && (
                        <TableRow>
                            <TableCell colSpan={2} align="center">
                                <Typography variant="body2" color="text.secondary" sx={{ py: 1.5 }}>{emptyText}</Typography>
                            </TableCell>
                        </TableRow>
                    )}
                    {rows?.map((row, index) => (
                        <TableRow key={index} hover>
                            <TableCell>{getLabel(row)}</TableCell>
                            <TableCell align="right">
                                <Chip label={getCount(row)} size="small" sx={{ fontWeight: 600, bgcolor: "#eef1f5" }} />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )

    render() {
        const {
            csLeadsReport, csLeadsReporLoading,
            csComplaintCategoriesReport, csComplaintCategoriesLoading, dataCsComplaintCategories,
            csHelpCategoriesReport, csHelpCategoriesLoading, dataCsHelpCategories,
            csSatisfactionReport, csSatisfactionLoading, dataCsCustomerSatisfaction,
            csRevisionNotes, csRevisionNotesLoading,
            users, selectedUser,
        } = this.state;

        return (
            <Box width={"100%"}>
                {/* === Filter === */}
                <Paper variant="outlined" sx={{ borderRadius: "10px", p: 1.5, mb: 2, bgcolor: "#fafafa" }}>
                    <Grid container spacing={1.5} alignItems="center">
                        <Grid item xs={12} sm={5}>
                            <Typography variant="subtitle1" fontWeight={700}>CS Report</Typography>
                            <Typography variant="caption" color="text.secondary">Rekap performa CS berdasarkan rentang tanggal & agent</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <Autocomplete
                                id="free-solo-2-demo"
                                disableClearable = {true}
                                freeSolo
                                size='small'
                                options={users.map((option) => String(`${option.name}`))}
                                onChange={(event, newValue) => {
                                    this.handleSelectionChanged(newValue);
                                }}
                                value={selectedUser?.name ?? ""}
                                renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Nama CS"
                                    variant="outlined"
                                    InputProps={{ ...params.InputProps, type: 'search' }}
                                    size='small'
                                />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12} sm={3} textAlign={{ xs: "left", sm: "right" }}>
                            <DateRangePickerRich title={"Tanggal Transaksi"} startDate={this.state.startDate} endDate={this.state.endDate} onDateChanged={this.handleDateChanged} />
                        </Grid>
                    </Grid>
                </Paper>

                {/* === Content === */}
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        {this.renderCard({
                            icon: <Groups sx={{ fontSize: 20, color: "primary.main" }} />,
                            title: "Leads Distribution",
                            loading: csLeadsReporLoading,
                            children: this.renderCountTable(
                                ["Agent", "Leads"],
                                csLeadsReport,
                                (row) => row.csName,
                                (row) => row.leads.length,
                                "Tidak ada data leads."
                            ),
                        })}
                    </Grid>

                    <Grid item xs={12} md={8}>
                        {this.renderCard({
                            icon: <RateReview sx={{ fontSize: 20, color: "primary.main" }} />,
                            title: "Revision Notes",
                            loading: csRevisionNotesLoading,
                            children: (
                                <TableContainer>
                                    <Table size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell sx={{ fontWeight: 700, bgcolor: "#f5f5f5" }}>Order</TableCell>
                                                <TableCell sx={{ fontWeight: 700, bgcolor: "#f5f5f5" }}>Notes</TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {(!csRevisionNotes || csRevisionNotes.length === 0) && (
                                                <TableRow>
                                                    <TableCell colSpan={2} align="center">
                                                        <Typography variant="body2" color="text.secondary" sx={{ py: 1.5 }}>Tidak ada revision notes.</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                            {csRevisionNotes?.map((group, index) => (
                                                <TableRow key={index} hover>
                                                    <TableCell sx={{ fontFamily: "monospace" }}>{group.order_number}</TableCell>
                                                    <TableCell>{group.revision_image_log}</TableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            ),
                        })}
                    </Grid>

                    <Grid item xs={12} md={4}>
                        {this.renderCard({
                            icon: <HelpOutline sx={{ fontSize: 20, color: "primary.main" }} />,
                            title: "Kategori Bantuan",
                            loading: csComplaintCategoriesLoading,
                            children: (
                                <>
                                    {this.renderCountTable(
                                        ["Kategori Bantuan", "Total"],
                                        csComplaintCategoriesReport,
                                        (row) => row.complaintCategory,
                                        (row) => row.leads.length,
                                        "Tidak ada data kategori bantuan."
                                    )}
                                    {!csComplaintCategoriesLoading && (
                                        <Box sx={{ maxWidth: 220, mx: "auto", pt: 2 }}>
                                            <Pie data={dataCsComplaintCategories} />
                                        </Box>
                                    )}
                                </>
                            ),
                        })}
                    </Grid>

                    <Grid item xs={12} md={8}>
                        {this.renderCard({
                            icon: <SentimentSatisfiedAlt sx={{ fontSize: 20, color: "primary.main" }} />,
                            title: "Customer Satisfaction Report",
                            loading: csSatisfactionLoading,
                            children: (
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item xs={12} sm={7}>
                                        {this.renderCountTable(
                                            ["Review", "Total"],
                                            csSatisfactionReport,
                                            (row) => row.review,
                                            (row) => row.leads.length,
                                            "Tidak ada data satisfaction."
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        {!csSatisfactionLoading && (
                                            <Box sx={{ maxWidth: 200, mx: "auto" }}>
                                                <Pie data={dataCsCustomerSatisfaction} />
                                            </Box>
                                        )}
                                    </Grid>
                                </Grid>
                            ),
                        })}
                    </Grid>

                    <Grid item xs={12}>
                        {this.renderCard({
                            icon: <ReportProblem sx={{ fontSize: 20, color: "primary.main" }} />,
                            title: "Kategori Complaint",
                            loading: csHelpCategoriesLoading,
                            children: (
                                <Grid container spacing={1} alignItems="center">
                                    <Grid item xs={12} sm={7}>
                                        {this.renderCountTable(
                                            ["Kategori Complaint", "Total"],
                                            csHelpCategoriesReport,
                                            (row) => row.helpCategory,
                                            (row) => row.leads.length,
                                            "Tidak ada data kategori complaint."
                                        )}
                                    </Grid>
                                    <Grid item xs={12} sm={5}>
                                        {!csHelpCategoriesLoading && (
                                            <Box sx={{ maxWidth: 220, mx: "auto" }}>
                                                <Pie data={dataCsHelpCategories} />
                                            </Box>
                                        )}
                                    </Grid>
                                </Grid>
                            ),
                        })}
                    </Grid>
                </Grid>
            </Box>
        );
    }
}
 
export default CsReport;